"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SiteFooter = _interopRequireDefault(require("./SiteFooter.variants"));
require("./SiteFooter.css");
var SiteFooter = function SiteFooter(props) {
  var variation = props.variation,
    className = props.className,
    rest = (0, _objectWithoutProperties2["default"])(props, ["variation", "className"]);
  var Body = _SiteFooter["default"].mainBody[variation];
  var Footer = _SiteFooter["default"].footer[variation];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Body, rest), /*#__PURE__*/_react["default"].createElement(Footer, rest));
};
SiteFooter.propTypes = {
  variation: _propTypes["default"].oneOf(['ExtensiveSitemap', 'CenterStacked', 'BasicFishermanBanner', 'CenterStackedV2', 'Simple', 'Services', 'SubscriptionBanner']),
  pages: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    pageTitle: _propTypes["default"].string.isRequired,
    slug: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool.isRequired
  }))).isRequired,
  ctas: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool.isRequired
  })),
  contactInformation: _propTypes["default"].shape({
    address: _propTypes["default"].shape({
      street: _propTypes["default"].string.isRequired,
      city: _propTypes["default"].string.isRequired,
      state: _propTypes["default"].string.isRequired,
      zip: _propTypes["default"].string.isRequired
    }),
    phoneNumber: _propTypes["default"].string.isRequired,
    email: _propTypes["default"].string
  }),
  socialMedia: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string.isRequired
  })),
  services: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    content: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string.isRequired
  })),
  hours: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    day: _propTypes["default"].number.isRequired,
    open: _propTypes["default"].number.isRequired,
    close: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string
  })),
  subscribe: _propTypes["default"].shape({
    header: _propTypes["default"].string.isRequired,
    placeholder: _propTypes["default"].string.isRequired
  }),
  aboutUs: _propTypes["default"].shape({
    header: _propTypes["default"].string.isRequired,
    content: _propTypes["default"].string.isRequired
  }),
  termsOfService: _propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string.isRequired
  }),
  copyright: _propTypes["default"].shape({
    company: _propTypes["default"].string.isRequired,
    phrase: _propTypes["default"].string.isRequired
  }),
  logo: _propTypes["default"].string,
  bodyColor: _propTypes["default"].string,
  bottomColor: _propTypes["default"].string,
  className: _propTypes["default"].string
};
SiteFooter.defaultProps = {
  variation: 'ExtensiveSitemap',
  className: 'fc-footer',
  ctas: [],
  services: [],
  contactInformation: null,
  socialMedia: [],
  hours: [],
  subscribe: null,
  aboutUs: null,
  termsOfService: null,
  copyright: null,
  logo: '',
  bodyColor: '#C9DAF4',
  bottomColor: '#90ACD7'
};
var _default = SiteFooter;
exports["default"] = _default;